<template>
  <div class="sinfo_list">
    <div
      class="content_list"
      v-for="(item, index) in infoList"
      :key="index"
      @click="showDetail(item)"
    >
      <p class="content_list_firstp">·</p>
      <p class="content_list_lastp">{{ item.title }}</p>
      <span>{{ item.time }}</span>
    </div>
  </div>
</template>

<script>
import { setVideoRecord, getIntegralUrl } from "@/api/moudles/home.js";
export default {
  data() {
    return {};
  },
  props: {
    infoList: {
      type: Array,
      default: () => [],
    },
    toPath: {
      type: String,
      default: "videoplay",
    },
  },
  watch: {
    // column_code(newValue) {
    //   this.columnCode = newValue;
    //   this.getInformation(newValue, 1, this.page_size, "1");
    // },
  },
  created() {
    const screenWidth = window.screen.width;
    if (screenWidth < 760) {
      this.layout = "prev, pager, next";
    }
    if (screenWidth > 760) {
      this.layout = "total, sizes, prev, pager, next, jumper";
    }
  },
  methods: {
    async showDetail(item) {
      const token = this.$store.state.user.token;
      console.log("item", item);
      console.log("token", token);

      if (item.points > 0 && !token) {
        // 需要积分的咨询
        this.$message("请先登录后再查看！");
      } else if (item.points == 0) {
        // 积分为0的咨询和视频
        if (item.type == "资讯") {
          this.seeNews(item);
        } else if (item.type == "视频") {
          this.seeVideo(item);
        }
        // 记录访问量
        this.setVideoRecord("1", item.id);
      } else {
        // 积分大于0需要扣积分
        if (item.type == "资讯") {
          // 资讯扣积分
          this.getIntegral("news", item).then((res) => {
            if (res) {
              window.open(res);
            }
          });
        } else if (item.type == "视频") {
          this.getIntegral("video", item).then((res) => {
            if (res) {
              this.seeVideo(item);
            } else {
              this.$message(res);
            }
          });
        }
      }
    },
    // 资讯访问
    seeNews(item) {
      if (item.wx_link) {
        window.open(item.wx_link);
      } else {
        this.$emit("activeList");
        const screenWidth = window.screen.width;
        if (screenWidth < 760) {
          this.$router.push(`/phoneIndex/info/detail/${item.id}`);
        } else {
          this.$router.push(`/info/detail/${item.id}`);
        }
      }
    },
    // 视频访问
    seeVideo(item) {
      // 是否会员
      if (item.isVip === 1) {
        // 登不登录都能看,有时间限制
        this.$router.push({
          name: this.toPath,
          params: {
            video_id: item.id,
            freeTime: item.freeTime,
            isVip: true,
          },
        });
      } else {
        // // 免费
        this.$router.push({
          name: this.toPath,
          params: {
            video_id: item.id,
            isVip: false,
          },
        });
      }
    },
    // 扣积分函数
    async getIntegral(type, item) {
      return new Promise((resolve, reject) => {
        getIntegralUrl({
          data: {
            type,
            id: item.id,
          },
          success: (res) => {
            if (res.data) {
              resolve(res.data);
              this.setVideoRecord("1", item.id);
            } else {
              reject(res.msg);
              this.$message(res.msg);
            }
          },
        });
      });
    },
    // 提交视频播放记录
    async setVideoRecord(type, newsId) {
      await setVideoRecord({
        data: {
          type,
          newsId,
          userId: "",
        },
      });
    },
  },
};
</script>

<style scoped>
.sinfo_list_head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.sinfo_list_head p {
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #131415;
  letter-spacing: 0;
  font-weight: 600;
}

.big_title_box {
  min-width: 100px;
  display: flex;
  height: 40px;
  line-height: 40px;
  padding-right: 10px;
}

.big_title_p {
  min-width: 100px;
  font-family: PingFangSC-Semibold;
  font-size: 24px;
  color: #131415;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
  margin-left: 15px;
}

/* 咨询列表-可复用 */
.content_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px 0 20px;
  border-bottom: 2px dotted #f5f5f5;
}

.content_list p:hover {
  color: #015aaa;
  text-decoration: underline;
  cursor: pointer;
}

.content_list_firstp {
  font-size: 35px;
}

.content_list_lastp {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 24px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 120px);
}

.content_list span {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 24px;
  font-weight: 400;
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 120px;
}

.sinfo_list_head_span {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #d40d16;
  letter-spacing: 0;
  text-align: center;
  line-height: 40px;
  font-weight: 400;
}

.sinfo_list_head_span:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
